import React from 'react';
import cn from 'classnames';

export default function EyeIcon({ onClick, ariaLabel = 'View details', className, ...rest }) {
  const isInteractive = typeof onClick === 'function';

  const handleKeyPress = (e) => {
    if (!isInteractive) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <i
      className={cn('icon-eye', className)}
      role={isInteractive ? 'button' : 'img'}
      tabIndex={isInteractive ? 0 : undefined}
      aria-label={ariaLabel}
      onClick={onClick}
      onKeyPress={isInteractive ? handleKeyPress : undefined}
      {...rest}
    />
  );
}
